import type { EventMap } from '@/core/EventBus';

const pad = (n: number): string => n.toString().padStart(2, '0');

export function formatTime(sec: number): string {
  const s = Math.max(0, Math.floor(sec));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  return h > 0 ? `${h}:${pad(m)}:${pad(s % 60)}` : `${pad(m)}:${pad(s % 60)}`;
}

/** 950 → "950", 100000 → "100K", 1250000 → "1.25M". */
export function formatShort(n: number): string {
  const v = Math.floor(n);
  if (v >= 1_000_000) return `${+(v / 1_000_000).toFixed(2)}M`;
  if (v >= 1_000) return `${+(v / 1_000).toFixed(1)}K`;
  return String(v);
}

/** "Level 1 · 100K", "Level 2 · 1.2M", "Level 2 ✓". */
export function formatProgress(tier: number, cellMax: number, multicellMax: number): string {
  if (tier >= 2) return 'Level 2 ✓';
  if (tier === 1) return multicellMax > 0 ? `Level 2 · ${formatShort(multicellMax)}` : 'Level 2';
  return `Level 1 · ${formatShort(cellMax)}`;
}

/** One-line result text for stage-complete screens / banners. */
export function describeScoreResult(p: EventMap['score:submitted']): string {
  const score = p.score.toLocaleString();
  switch (p.status) {
    case 'ok': return `Score ${score} · rank #${p.rank} on the scoreboard`;
    case 'unranked': return `Score ${score} · unranked (dev shortcut used)`;
    case 'offline': return `Score ${score} · scoreboard unreachable, will retry`;
  }
}
